export interface ApplicationLog {
  id: number;
  message: string;
  level: string;
  timeStamp: string;
  exception?: string;
  machineName?: string;
  applicationName?: string;
  operatorId?: string;
  operatorName?: string;
  companyNo?: string;
  customerNo?: string;
  requestPath?: string;
  requestMethod?: string;
  clientIP?: string;
  correlationId?: string;
}

export interface LogFilter {
  pageSize: number;
  pageNumber: number;
  level?: string;
  fromDate?: string;
  toDate?: string;
  operatorId?: string;
  correlationId?: string;
  searchTerm?: string;
}

export interface LogResponse {
  logs: ApplicationLog[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface LogStatistics {
  levelCounts: Record<string, number>;
  totalCount: number;
  fromDate?: string;
  toDate?: string;
}

export type LogLevel = 'Information' | 'Warning' | 'Error' | 'Critical' | 'Debug';

export const LOG_LEVEL_COLORS: Record<LogLevel, string> = {
  Information: 'text-blue-600',
  Warning: 'text-yellow-600',
  Error: 'text-red-600',
  Critical: 'text-red-800',
  Debug: 'text-gray-600'
};

export const LOG_LEVEL_BG_COLORS: Record<LogLevel, string> = {
  Information: 'bg-blue-50',
  Warning: 'bg-yellow-50',
  Error: 'bg-red-50',
  Critical: 'bg-red-100',
  Debug: 'bg-gray-50'
};